import { normalizeEventKey } from './dom.esm.js';
import { runIfFn } from './function.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
function createOnKeyDown(options) {
  var keyMap = options.keyMap,
      onKey = options.onKey,
      stopPropagation = options.stopPropagation,
      onKeyDown = options.onKeyDown,
      _options$shouldKeyDow = options.shouldKeyDown,
      shouldKeyDown = _options$shouldKeyDow === void 0 ? function () {
    return true;
  } : _options$shouldKeyDow,
      _options$preventDefau = options.preventDefault,
      preventDefault = _options$preventDefau === void 0 ? true : _options$preventDefau;
  return function (event) {
    if (!keyMap) return;
    var finalKeyMap = runIfFn(keyMap, event);
    var shouldPreventDefault = runIfFn(preventDefault, event);
    var shouldStopPropagation = runIfFn(stopPropagation, event);
    var eventKey = normalizeEventKey(event);

    if (eventKey in finalKeyMap) {
      var action = finalKeyMap[eventKey];

      if (typeof action === 'function' && shouldKeyDown(event)) {
        if (shouldPreventDefault) event.preventDefault();
        if (shouldStopPropagation) event.stopPropagation();
        onKey == null ? void 0 : onKey(event);
        action(event);
        return;
      }
    }

    onKeyDown == null ? void 0 : onKeyDown(event);
  };
}

export { createOnKeyDown };
//# sourceMappingURL=keydown.esm.js.map
